import { useContent } from "@/context/ContentContext";
import Awards from "@/components/site/Awards";
import FirstsAndOnlys from "@/components/site/FirstsAndOnlys";
import PageLoader from "@/components/site/PageLoader";

export default function AwardsPage() {
  const c = useContent();
  if (!c) return <PageLoader />;
  return (
    <>
      <Awards items={c.awards || []} />
      <FirstsAndOnlys />
    </>
  );
}
